export default "__VITE_ASSET__CGr9f4Bu__"